.component {
  flex: 1;
  /* margin-right: 10px; */
  height: 38px;
  position: relative;
}

.menuTitle {
  color: var(--turquoise);
  padding: 16px 14px 4px 14px;
  margin-bottom: 16px;
  border-bottom: dotted 3px var(--pinkish-grey);    
  font-size: 15px;
  text-transform: uppercase;
}

.menuHint {
  color: var(--brown-grey);
  padding: 0 14px 8px 14px;
  font-size: 12px;
  font-style: italic;
}

.timeChipLabel {
  cursor: pointer;
}

.timeChipLabel:hover {
  text-decoration: underline;
}